module.exports = __webpack_public_path__ + "img/figure.c16f2f3b.png";